/**
 * Helper function to get incentive value for display
 * @param {Object} incentive - The incentive object
 * @returns {number} The cash value to display
 */

const getIncentiveValue = incentive => incentive.cash || incentive.termRebates?.incentiveTermRange?.reduce((max, term) => Math.max(max, term.customerCash || 0), 0) || 0;
export { getIncentiveValue as default };
